<app-icon-list></app-icon-list>

<div
  class="router-outlet-wrapper"
  [preventWindowUnloading]="preventWindowUnloadingOptions"
>
  <router-outlet></router-outlet>
</div>

<div class="toaster-wrapper">
  <app-toaster></app-toaster>
</div>

<i2g-dialog-manager></i2g-dialog-manager>

<app-loading-dialog></app-loading-dialog>

<i2g-tooltip-manager></i2g-tooltip-manager>

<i2g-toast-messages></i2g-toast-messages>
